/* 孫吳傳・第 17 章：白衣渡江（建安二十四年，219）
 * 史實：《三國志·呂蒙傳》「蒙至尋陽，盡伏其精兵𦨴𦪇中，使白衣搖櫓，作商賈人服，晝夜兼行，至羽所置江邊屯候，盡收縛之，是故羽不聞知。」
 * 流程：呂蒙扮成商人，搖櫓到北岸的渡口上岸，沿江邊小路往江陵走。路上有關羽的三座烽火台，每座有三名屯候。
 *       屯候還不知情時，站到他身邊不動就能「收縛」；但旁邊的人看得到，走近、收縛時他們的疑心都會上升。
 *       一動手、或疑心滿了，屯候就識破；4 秒內沒把這座的屯候全解決，烽火就點著，下一座也會戒備。三座都點著，關羽就知道了（戰敗）。到江陵即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, TROOPS } from '../kit.ts';
import { TOWERS, DOCK, JIANGLING } from '../maps/jiangling.ts';

const LV = 14, START = [700, 2900], DAWN = 180;
const GUARD = { spec: TROOPS.shu, name: '屯候', hp: 520, maxHp: 520, atk: 28 };
const landOk = (x, y) => SG.gd(x, y, DOCK[0], DOCK[1]) < 400;

export default {
  id: 'sunwu-17', map: 'jiangling', hero: 'lvmeng',
  title: '第 15 章　白衣渡江', year: '建安二十四年（219）',
  brief: {
    quote: [{ text: '盡伏其精兵𦨴𦪇中，使白衣搖櫓，作商賈人服，晝夜兼行。', src: '《三國志·吳書·呂蒙傳》' }],
    text: '關羽北攻樊城，留兵守江陵、公安，沿江設烽火台（屯候），吳軍一動就點火報信。呂蒙把精兵藏在船艙裡，讓士兵穿白衣、扮成商人搖櫓。',
    goals: ['扮成商人，從渡口上岸', '悄悄收縛三座烽火台的屯候', '天亮前到江陵'],
  },
  words: { ally: '精兵', foe: '屯候' },
  stars: [
    { text: '如史：一座烽火都沒點著', ok: (m) => m.vars.lit === 0 },
    { text: '屯候全部收縛（沒有殺人）', ok: (m) => m.vars.bound === 9 },
    { text: '天亮前一分半鐘就到江陵', ok: (m) => m.vars.arriveT != null && m.vars.arriveT < DAWN - 90 },
  ],
  steps: [
    { // 1. 白衣搖櫓
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        V.t0 = w.t; V.lit = 0; V.bound = 0;
        V.b = m.boat(me, { x: START[0], y: START[1], sp: 200, crew: [], land: true, landOk, col: '#8a7a5a', onLand: () => {} });
        V.men = []; // 精兵藏在船艙裡：上岸才出來
        V.towers = TOWERS.map(([x, y], k) => {
          const g = Array.from({ length: 3 }, (_, i) => { const u = m.foe('huangjin', x - 160 + i * 160, y + 140 + (i % 2) * 50, GUARD); u.asleep = true; u.sus = 0; u.tower = k; return u; }); // asleep：還不知情（部下不會去打）
          const fire = m.folk(x, y - 40, { name: '烽火台', still: true, near: 1, draw: beacon, lit: false });
          m.mark('t' + k, x, y - 60, '烽火台', true);
          return { x, y, g, fire, alert: false };
        });
        m.card('使白衣搖櫓，作商賈人服。', '《呂蒙傳》');
        m.line('呂蒙', '弟兄們藏好。我們只是販布的商人。');
        m.after(4, () => m.line('提示', '右鍵點江面划船，到北岸的渡口上岸。上岸後不要出手：一動手屯候就會去點烽火。'));
        m.mark('dock', DOCK[0], DOCK[1], '渡口');
        m.obj('land', '從北岸的渡口上岸');
        m.obj('dawn', '');
      },
      tick(m, w) { return !w.player.boat; },
    },
    { // 2. 盡收縛之
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('land'); m.unmark('dock');
        V.men = Array.from({ length: 6 }, (_, i) => { const p = SG.MAP.nearestFree(me.x - 80 - (i % 3) * 40, me.y + 30); const u = m.recruit(p[0], p[1], '精兵'); m.join(u, me); return u; });
        m.line('呂蒙', '上岸了。往東走，見到屯候先別動手。');
        m.after(3, () => m.line('提示', '站在不知情的屯候身邊不動，就能收縛他（旁邊的人會起疑）。屯候頭上會顯示疑心。'));
        m.obj('bind', '收縛屯候', 9);
        m.mark('jl', JIANGLING[0], JIANGLING[1], '江陵');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        m.prog('bind', V.bound);
        for (const T of V.towers) for (const u of T.g) {
          if (!u.alive || !u.asleep) continue;
          m.chanAt(me, 'bind' + u.id, u.x, u.y, 110, 1.2, '收縛', () => {
            if (!u.alive || !u.asleep) return;
            u.alive = false; u.counted = true; u.bound = true; V.bound++;
            m.folk(u.x, u.y, { name: '被縛的屯候', still: true, near: 1, lying: true, cloth: '#2f5e3f' });
          });
        }
        if (m.near(me, JIANGLING[0], JIANGLING[1], 380)) return true;
        return false;
      },
    },
    { // 3. 羽不聞知
      enter(m, w) {
        const V = m.vars;
        V.arriveT = w.t - V.t0;
        m.done('bind'); m.done('dawn'); m.unmark('jl');
        if (V.lit) m.line('旁白', '烽火雖然點起，吳軍還是搶先到了江陵。'); else m.card('至羽所置江邊屯候，盡收縛之，是故羽不聞知。', '《呂蒙傳》');
        m.after(5, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w, dt) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('呂蒙陣亡'); return; }
    if (!V.towers) return;
    const left = DAWN - (w.t - V.t0), o = m.get('dawn');
    if (o) o.text = `天亮前到江陵（還有 ${Math.max(0, Math.ceil(left))} 秒）`;
    if (left <= 0) { m.lose('天亮了，商船露了餡'); return; }
    const hostile = me.act || V.men.some((u) => u.alive && u.target && u.target.alive && u.target.team === 1);
    V.towers.forEach((T, k) => {
      for (const u of T.g) {
        if (!u.alive) continue;
        const d = SG.gd(u.x, u.y, me.x, me.y);
        if (u.asleep) {
          // 疑心：走近 320 內慢慢上升；有同伴在被收縛時看得到，上升得快；看到動手就直接滿
          u.sus = Math.max(0, u.sus - dt * 4);
          if (d < 320) u.sus += dt * 10;
          if (T.g.some((o) => o !== u && o.alive && me.chan && me.chan.key === 'bind' + o.id) && d < 500) u.sus += dt * 22;
          if ((hostile && d < 600) || u.hp < u.maxHp) u.sus = 100; // 看到動手、或自己挨打
          if (T.alert && d < 500) u.sus = 100;
          if (T.alarmT != null) u.sus = 100; // 同一座有人喊了，大家都醒
          u.target = null; u.think = 0.5; u.home = u.home || [u.x, u.y];
          if (u.sus >= 100) { u.asleep = false; m.line('屯候', '是吳軍！快點烽火！'); }
        }
      }
      // 這座有人識破：4 秒後點起烽火，除非三個屯候在那之前全被解決
      if (!T.fire.lit && T.g.some((u) => u.alive && !u.asleep)) {
        if (T.alarmT == null) { T.alarmT = 4; m.big('屯候要點烽火了！'); }
        T.alarmT -= dt;
        if (T.alarmT <= 0) {
          T.fire.lit = true; V.lit++; m.unmark('t' + k);
          m.big('烽火點著了！');
          const next = V.towers[k + 1]; if (next) next.alert = true;
          if (V.lit >= 3) m.lose('三座烽火都點著了，關羽已經知道');
        }
      }
      if (!T.g.some((u) => u.alive)) T.alarmT = null;
    });
  },
};

// 烽火台：夯土台、頂上一堆柴；點著了就冒火與黑煙
function beacon(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 6, 4, 60, 16, 90, 0.35);
  poly(ctx, [[-46, 0], [46, 0], [34, -90], [-34, -90]], '#9a8462', 2.2);
  poly(ctx, [[-30, -90], [30, -90], [0, -118]], '#6a5030', 1.8);
  if (f.lit) {
    for (let i = 0; i < 3; i++) { const h = 50 + 16 * Math.sin(T * 8 + i); ctx.fillStyle = '#e8541c'; ctx.beginPath(); ctx.moveTo(-22 + i * 22 - 14, -96); ctx.quadraticCurveTo(-22 + i * 22, -96 - h, -22 + i * 22 + 14, -96); ctx.fill(); }
    ctx.fillStyle = 'rgba(40,36,32,.45)'; for (let i = 0; i < 4; i++) { ctx.beginPath(); ctx.arc(Math.sin(T + i) * 20, -170 - ((T * 40 + i * 40) % 160), 22 + i * 4, 0, Math.PI * 2); ctx.fill(); }
  }
  ctx.restore();
}
